var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNzDots = function SvgNzDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187,
    height: 282,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M10.33 281.98a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M92.76 201.62a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M166.186 44.96c.845-5.207-2.69-10.113-7.896-10.958a9.55 9.55 0 0 0-10.957 7.897c-.845 5.206 2.69 10.112 7.896 10.957s10.112-2.69 10.957-7.897M176.78 105.49a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M150.598 13.259c.845-5.207-2.691-10.112-7.897-10.957s-10.112 2.69-10.957 7.896 2.691 10.112 7.897 10.957 10.112-2.69 10.957-7.897"
  })));
};
export default SvgNzDots;